export const ProposalIcon = () => {
  return (
    <svg
      aria-label="proposal"
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11H8M9 15H8M16 7H8M20 9.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H10.5"
        stroke="#66736F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2222 14.6522L17.5 17.2756M17.5 17.2756L12.7778 14.6522M17.5 17.2756L17.5 22.5534M15 13.109L20 15.8867M22.5 19.5304V15.0209C22.5 14.8305 22.5 14.7353 22.472 14.6505C22.4471 14.5754 22.4066 14.5064 22.353 14.4483C22.2924 14.3825 22.2092 14.3363 22.0428 14.2438L17.9317 11.9599C17.7741 11.8724 17.6953 11.8286 17.6119 11.8114C17.5381 11.7963 17.4619 11.7963 17.3881 11.8114C17.3047 11.8286 17.2259 11.8724 17.0683 11.9599L12.9572 14.2438C12.7908 14.3363 12.7076 14.3825 12.647 14.4483C12.5934 14.5064 12.5529 14.5754 12.528 14.6505C12.5 14.7353 12.5 14.8305 12.5 15.0209V19.5304C12.5 19.7207 12.5 19.8159 12.528 19.9008C12.5529 19.9759 12.5934 20.0448 12.647 20.103C12.7076 20.1687 12.7908 20.215 12.9572 20.3074L17.0683 22.5914C17.2259 22.6789 17.3047 22.7227 17.3881 22.7398C17.4619 22.755 17.5381 22.755 17.6119 22.7398C17.6953 22.7227 17.7741 22.6789 17.9317 22.5914L22.0428 20.3074C22.2092 20.215 22.2924 20.1687 22.353 20.103C22.4066 20.0448 22.4471 19.9759 22.472 19.9008C22.5 19.8159 22.5 19.7207 22.5 19.5304Z"
        stroke="#66736F"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
